module.exports = __webpack_public_path__ + "static/Slide-01-c7d7d70f895d9705f8e9e582e1d2895e.png";